import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "../lib/apiClient";
import { Logo } from "../components/Logo";
import { Seo } from "../components/Seo";

// One-time password reset link landing: /reset-password?token=…
export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 6) return setError("Use at least 6 characters.");
    if (pw !== pw2) return setError("The two passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      toast.success("Password changed. Please sign in.");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "This reset link is invalid, already used or expired.");
    }
    setBusy(false);
  };
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <Seo title="Choose a new password" noindex />
      <div className="w-full max-w-md bg-white rounded-3xl border border-line shadow-card p-8" data-testid="reset-password-card">
        <button onClick={() => navigate("/")} className="mb-6"><Logo height="h-10" /></button>
        <h1 className="font-heading font-black text-3xl text-ink">Choose a new password</h1>
        {!token && <p className="text-ink-soft mt-2" data-testid="reset-missing-token">This link is incomplete. <button onClick={() => navigate("/auth")} className="text-brand font-bold">Request a new one</button>.</p>}
        {done ? (
          <div className="mt-6 space-y-4" data-testid="reset-done">
            <p className="text-ink">Your password has been changed. This link can't be used again.</p>
            <button onClick={() => navigate("/auth")} data-testid="reset-go-signin" className="w-full h-14 rounded-full bg-brand text-white font-bold text-lg hover:bg-brand-hover">Sign in</button>
          </div>
        ) : token && (
          <form onSubmit={submit} className="mt-6 space-y-4">
            {error && <p className="rounded-2xl bg-blush border border-brand/30 p-3 text-sm text-ink" role="alert" data-testid="reset-error">{error}</p>}
            <div><label htmlFor="reset-pw" className="text-sm font-bold text-ink">New password</label>
              <input id="reset-pw" type="password" autoComplete="new-password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" className="mt-1.5 w-full h-14 px-5 rounded-2xl border-2 border-line bg-white focus:border-brand outline-none" /></div>
            <div><label htmlFor="reset-pw2" className="text-sm font-bold text-ink">Repeat new password</label>
              <input id="reset-pw2" type="password" autoComplete="new-password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" className="mt-1.5 w-full h-14 px-5 rounded-2xl border-2 border-line bg-white focus:border-brand outline-none" /></div>
            <button type="submit" disabled={busy} data-testid="reset-submit-btn" className="w-full h-14 rounded-full bg-brand text-white font-bold text-lg hover:bg-brand-hover disabled:opacity-60">{busy ? "Saving…" : "Save new password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
